import { LessonsCarouselParams } from '@yandex-int/k-common/typings/api/models/main-page';
import React from 'react';

import { ShowcaseMetrikaParams } from 'common.components/typings';
import { LessonsCarouselsCarousel } from 'common.components/widgets.lessons-carousels/__carousel/lessons-carousels_carousel';
import { WidgetWrapper } from 'common.components/widgets.widget-wrapper/widget-wrapper';
import { b } from './cn';

import './lessons-carousels.scss';

export interface Props {
    carousels: LessonsCarouselParams[];
    metrikaParams?: ShowcaseMetrikaParams;
}

export const LessonsCarouselsWidget = ({ carousels }: Props) => {
    return (
        <WidgetWrapper className={b('wrapper')} fullWidth>
            <div className={b()}>
                {carousels.map((carousel) => (
                    <LessonsCarouselsCarousel {...carousel} />
                ))}
            </div>
        </WidgetWrapper>
    );
};
